import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Popover, Row, Space, Spin, Table } from "antd";
import { ColumnPopoverDisplay, InputFields, ModalCustom } from "components/common";
import { ExcelSVG } from "assets";
import Icon from "assets/icons";
import dayjs from "dayjs";
import {
  payService,
  employeeService,
  medicalExaminationService,
  accoutingFinancial,
  discountsService,
} from "api";
import Notification from "components/common/notification/notification";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { formatToCurrencyType } from "helper/common";
import { ColumnProps } from "../../../types/models";
import {
  gioiTinhOptions,
  loaiKCBOptions,
} from "assets/constants/select-catagory-options";
import ObjectTypeColumn from "components/common/ColumnColors/KCBTypeColumn/ObjectTypeColumn";
import { field } from "pages/Pay/PushDataXML/PushDataXML.config";
import { RangePickerProps } from "antd/es/date-picker";
const {
  INPUT,
  SELECT,
  DATE,
  CODE,
  COMBO_BOX,
  AUTO_COMPLETE,
  DATE_DISABLE_NO_DAY,
} = FIELD_TYPE;

const Marketing = () => {
  const columnsTable: any = [
    // {
    //   title: "STT",
    //   dataIndex: "stt",
    //   key: "stt",
    //   width: "40px",
    //   render: (text, record, index) => index + 1,
    //   align: "center",
    // },
    {
      title: "Mã bệnh nhân",
      dataIndex: "maBenhNhan",
      key: "maBenhNhan",
      // width: '100px',
      align: "center",
      show: true,
    },
    {
      title: "Mã phiếu khám",
      dataIndex: "maPhieuKham",
      key: "maPhieuKham",
      // width: '8%',
      align: "center",
      show: true,
    },
    {
      title: "Tên bệnh nhân",
      dataIndex: "tenBenhNhan",
      key: "tenBenhNhan",
      // width: '100px',
      align: "left",
      show: true,
    },
    {
      title: "Ngày sinh",
      dataIndex: "ngaySinh",
      key: "ngaySinh",
      // width: '8%',
      align: "center",
      show: true,
      render: (v, r, idx) =>
        v !== null ? dayjs(v).format("DD/MM/YYYY") : null,
    },
    {
      title: "Giới tính",
      dataIndex: "gioiTinh",
      key: "gioiTinh",
      // width: '100px',
      align: "center",
      render: (text) => {
        if (text == "0") {
          return "Nam";
        } else if (text == "1") {
          return "Nữ";
        } else return text;
      },
      show: true,
    },
    {
      title: "Địa chỉ",
      dataIndex: "diaChi",
      key: "diaChi",
      // width: '100px',
      align: "left",
      show: true,
    },
    {
      title: "Số điện thoại",
      dataIndex: "soDienThoai",
      key: "soDienThoai",
      // width: '100px',
      align: "right",
      show: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      // width: '100px',
      align: "left",
      show: true,
    },
    {
      title: "Loại KCB",
      dataIndex: "loaiKCB",
      key: "loaiKCB",
      // width: '100px',
      align: "center",
      show: true,
      // render: (v, r, i) =>
      //   loaiKCBOptions.find((it) => it.value === v)?.label || "",
    },
    {
      title: "Lí do khám",
      dataIndex: "lyDoKham",
      key: "lyDoKham",
      // width: '100px',
      align: "left",
      show: true,
    },
    {
      title: "Nguồn bệnh nhân",
      dataIndex: "nguonBenhNhan",
      key: "nguonBenhNhan",
      // width: '8%',
      align: "left",
      show: true,
    },
    {
      title: "Chi tiết nguồn BN",
      dataIndex: "chiTietNguonBenhNhan",
      key: "chiTietNguonBenhNhan",
      // width: '8%',
      align: "left",
      show: true,
    },
    {
      title: "Đối tượng",
      dataIndex: "doiTuong",
      key: "doiTuong",
      align: "left",
      show: true,
      // render: (text) => {
      //   const ten =
      //     JSON.parse(localStorage.getItem("doiTuong")).find(
      //       (option) => option.label === text
      //     )?.label || "text";
      //   return <ObjectTypeColumn label={ten} />;
      // },
    },
    {
      title: "Chẩn đoán",
      dataIndex: "chanDoanBenh",
      key: "chanDoanBenh",
      align: "left",
      show: true,
    },
    {
      title: "Dịch vụ",
      dataIndex: "dichVus",
      key: "dichVus",
      align: "left",
      show: true,
    },
    {
      title: "SL",
      dataIndex: "soLuong",
      key: "soLuong",
      align: "right",
      show: true,
    },
    {
      title: "Đơn giá",
      dataIndex: "donGia",
      key: "donGia",
      align: "right",
      show: true,
      render: (v) => formatToCurrencyType(v),
    },
    {
      title: "Tổng thành tiền",
      dataIndex: "tongThanhTienDichVu",
      key: "tongThanhTienDichVu",
      align: "right",
      show: true,
      render: (v) => formatToCurrencyType(v),
    },
    {
      title: "Số tiền miễn giảm",
      dataIndex: "tongTienMienGiam",
      key: "tongTienMienGiam",
      align: "right",
      show: true,
      render: (v) => formatToCurrencyType(v),
    },
    {
      title: "Chương trình KM",
      dataIndex: "chuongTrinhUuDai",
      key: "chuongTrinhUuDai",
      align: "right",
      show: true,
    },
    {
      title: "Thực thu",
      dataIndex: "soTienGiaoDich",
      key: "soTienGiaoDich",
      align: "right",
      show: true,
      render: (v) => formatToCurrencyType(v),
    },
    {
      title: "Hình thức thanh toán",
      dataIndex: "hinhThucThanhToan",
      key: "hinhThucThanhToan",
      align: "left",
      show: true,
    },
    {
      title: "Trạng thái",
      dataIndex: "trangThaiHoaDon",
      key: "trangThaiHoaDon",
      align: "left",
      show: true,
    },
    {
      title: "Lí do",
      dataIndex: "lyDos",
      key: "lyDos",
      align: "left",
      show: true,
    },
  ];
  const dataField: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      name: "maBenhNhan",
      placeholder: "Nhập",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
        {
          max: 10,
          message: "Định dạng mã bệnh nhân không đúng",
        },
      ],
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      name: "soDienThoai",
      placeholder: "Nhập",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
        {
          max: 10,
          message: "Định dạng SĐT không đúng",
        },
      ],
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: SELECT,
      label: "Giới tính",
      name: "gioiTinh",
      placeholder: "Chọn",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      options: [
        { value: 0, label: "Nam" },
        { value: 1, label: "Nữ" },
      ],
    },
    {
      type: INPUT,
      label: "Mã phiếu khám",
      name: "maPhieuKham",
      placeholder: "Nhập",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
        {
          max: 10,
          message: "Định dạng mã phiếu khám không đúng",
        },
      ],
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: INPUT,
      label: "Tên bệnh nhân",
      name: "tenBenhNhan",
      placeholder: "Nhập",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      rules: [
        {
          max: 50,
          message: "Định dạng tên bệnh nhân không đúng",
        },
      ],
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    // {
    //   type: SELECT,
    //   label: "Tên thu ngân",
    //   name: "tenThuNgans",
    //   mode: "multiple",
    //   placeholder: "Nhập",
    //   css: {
    //     xl: 12,
    //     lg: 12,
    //     md: 12,
    //     sm: 12,
    //     xs: 24,
    //   },
    //   labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
    //   wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    // },
    {
      type: DATE_DISABLE_NO_DAY,
      disableDate: false,
      optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
      label: "Ngày sinh",
      name: "ngaySinh",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
    {
      type: SELECT,
      label: "Loại KCB",
      name: "loaiKCB",
      placeholder: "Chọn",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      options: JSON.parse(localStorage.getItem("loaiKCB")) || [],
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },

    {
      type: SELECT,
      label: "Nguồn BN",
      name: "nguonBenhNhan",
      placeholder: "Chọn",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: SELECT,
      label: "Đối tượng",
      name: "doiTuong",
      placeholder: "Chọn",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: DATE,
      disableDate: false,
      needConfirm:false,
      optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
      label: "Ngày tạo từ",
      name: "start",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
    {
      type: DATE,
      disableDate: false,
      needConfirm:false,
      optionsTime: { format: FORMAT_TIME.dateTime, showTime: true },
      label: "Ngày tạo đến",
      name: "end",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
      // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
    {
      type: COMBO_BOX,
      label: "Chương trình KM",
      name: "chuongTrinhUuDai",
      placeholder: "Chọn",
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: SELECT,
      label: "Trạng thái",
      name: "trangThai",
      placeholder: "Chọn",
      options: [
        {
          value: 0,
          label: "Đã thanh toán",
          code: "DTT",
        },
        {
          value: 1,
          label: "Hủy thanh toán",
          code: "HTT",
        },
        {
          value: 2,
          label: "Hoàn phí",
          code: "HP",
        },
      ],
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
    {
      type: SELECT,
      label: "Loại dịch vụ",
      name: "type",
      placeholder: "Chọn",
      options: [
        { value: 0, label: "Ngoại trú" },
        { value: 1, label: "Nội trú" },
      ],
      css: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 24,
      },
      labelCol: { xs: 24, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 24, md: 16, lg: 16, xl: 16 },
    },
  ];
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(columnsTable);
  const [fields, setFields] = useState(dataField);
  const [form] = Form.useForm();
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [idNhomDV, setIdNhomDV] = useState();
  useEffect(() => {
    getListNguonBN();
    fetchObjects();
    getListCCKM();
  }, []);
  // useEffect(() => {
  //   const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
  //     const endDay = form.getFieldValue("end");
  //     if (endDay) {
  //       const endDate = dayjs(endDay).startOf("day");
  //       const startDate = dayjs(currentDate).startOf("day");
  //       const diffDays = endDate.diff(startDate, 'days');
  //       return diffDays > 20 || diffDays < 0; // Kiểm tra nếu số ngày lớn hơn 20 hoặc ngày bắt đầu lớn hơn ngày kết thúc
  //     }
  //     return currentDate > endDay;
  //   };
  //   const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
  //     const start = form.getFieldValue("start");
  //     if (start) {
  //       const startDate = dayjs(start).startOf("day");
  //     const endDate = dayjs(currentDate).startOf("day");
  //     return endDate.diff(startDate, 'days') > 20;
  //     }
  //     return currentDate < start;
  //   };
  //   fields.find(e => e.name == "start").disabledDate = disabledDateStart;
  //   fields.find(e => e.name == "end").disabledDate = disabledDateEnd;
  //   setFields([...fields]);
  // }, []);
  const getListNguonBN = async () => {
    try {
      const response = await medicalExaminationService.getSourcePatient();
      //console.log("Nguồn", response.data);
      fields.find((e) => e.name == "nguonBenhNhan").options = response.data.map(
        (e) => {
          return { value: e.tenNguonBenhNhan, label: e.tenNguonBenhNhan };
        }
      );
      setFields([...fields]);
    } catch (error) {
      Notification(
        "error",
        "Lỗi xảy ra khi lấy thông tin danh mục nguồn bênh nhân"
      );
    }
  };
  const getListCCKM = async () => {
    try {
      const response = await discountsService.searchKM();
     // console.log("Nguồn", response.data);
      fields.find((e) => e.name == "chuongTrinhUuDai").options = response.data.map(
        (e) => {
          return { value: e.tenChuongTrinh, label: e.tenChuongTrinh };
        }
      );
      setFields([...fields]);
    } catch (error) {
      Notification(
        "error",
        "Lỗi xảy ra khi lấy thông tin chương trình khuyến mãi"
      );
    }
  };
  const fetchObjects = async () => {
    try {
      const response = await medicalExaminationService.getListObjects();
      //  console.log(response.data);

      fields.find((e) => e.name == "doiTuong").options = response.data.map(
        (e) => {
          return { value: e.id, label: e.tenDoiTuong };
        }
      );
      setFields([...fields]);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  const handleOnFinish = () => {
    const data = form.getFieldsValue();
    // if (Array.isArray(data.tenThuNgans)) {
    //   data.tenThuNgans = data.tenThuNgans.join(","); // Chuyển thành chuỗi ngăn cách bằng dấu phẩy
    // }
    const dataParams = {
      ...data,
      start: dayjs(data.start).format(FORMAT_TIME.dateTimeH),
      end: dayjs(data.end).format(FORMAT_TIME.dateTimeH),
      ...(data.ngaySinh && {
        ngaySinh: dayjs(data.ngaySinh).format(FORMAT_TIME.dayFull),
      }),
    };
    const startDate = dayjs(data.start);
    const endDate = dayjs(data.end);
    const dateDifference = endDate.diff(startDate, 'day');
  
    if (dateDifference > 20) {
      Notification("warning", "Vui lòng chọn khoảng thời gian không vượt quá 20 ngày");
      setLoadingPage(false);
      return;
    }
    if (
      !dataParams.start ||
      !dataParams.end ||
      dataParams.start == "Invalid Date" ||
      dataParams.end == "Invalid Date"
    ) {
      Notification("warning", "Vui lòng chọn ngày");
      return;
    }
    getData(dataParams);
  };

  const getData = async (data) => {
    setLoading(true);
   // let timeoutId;
    try {
      // timeoutId = setTimeout(() => {
      //   setLoading(false);
      //   Notification("warning","Lấy thông tin báo cáo quá thời gian quy định (5 phút)");
      // }, 300000); // 5 minutes
      const response = await accoutingFinancial
        .getListMarketing(data)
        .then((res) => {
          setData(res.data);
          setLoading(false);
          Notification("success", "Lấy thông tin báo cáo thành công");
        });
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi lấy thông tin báo cáo");
    }
    // finally {
    //   clearTimeout(timeoutId);
    //   setLoading(false);
    // }
  };

  const addClass = (arr, idx) => {
    if (idx + 1 == arr.length) {
      return "";
    } else {
      return "border-bottom-cell";
    }
  };
  columns.map((col) => {
    if (col.dataIndex == "hinhThucThanhToan") {
      col.render = (value, record: any, index) => {
        return (
          <>
            {record.hoanThanhThanhToanDtos?.map((value, index) => (
              <div
                className={addClass(record.hoanThanhThanhToanDtos, index)}
                key={index}
              >
                {value?.hinhThucThanhToan}
              </div>
            ))}
          </>
        );
      };
    }
    if (col.dataIndex == "soTienGiaoDich") {
      col.render = (value, record: any, index) => {
        if (
          record.trangThaiHoaDon !== "Hoàn phí" &&
          record.trangThaiHoaDon !== "Hủy thanh toán"
        ) {
          return (
            <>
              {record.hoanThanhThanhToanDtos?.map((value, index) => (
                <div
                  className={addClass(record.hoanThanhThanhToanDtos, index)}
                  key={index}
                >
                  {formatToCurrencyType(value?.soTienGiaoDich)}
                </div>
              ))}
            </>
          );
        } else {
          return value; // Trả về null nếu không thỏa mãn điều kiện
        }
      };
    }

    if (col.dataIndex == "donGia") {
      col.render = (value, record: any, index) => {
        if (
          record.trangThaiHoaDon !== "Hoàn phí" &&
          record.trangThaiHoaDon !== "Hủy thanh toán"
        ) {
          return (
            <>
              {record.chiDinhDtos?.map((value, index) => (
                <div
                  className={addClass(record.chiDinhDtos, index)}
                  key={index}
                >
                  {formatToCurrencyType(value?.donGia)}
                </div>
              ))}
            </>
          );
        } else {
          return value;
        }
      };
    }
    if (col.dataIndex == "soLuong") {
      col.render = (value, record: any, index) => {
        if (
          record.trangThaiHoaDon !== "Hoàn phí" &&
          record.trangThaiHoaDon !== "Hủy thanh toán"
        ) {
          return (
            <>
              {record.chiDinhDtos?.map((value, index) => (
                <div
                  className={addClass(record.chiDinhDtos, index)}
                  key={index}
                >
                  {value?.soLuong}
                </div>
              ))}
            </>
          );
        } else {
          return value; // Trả về null nếu không thỏa mãn điều kiện
        }
      };
    }
  });

  const handelOnExport = async () => {
    setLoadingPage(true);
    const data = form.getFieldsValue();
    // if (Array.isArray(data.tenThuNgans)) {
    //   data.tenThuNgans = data.tenThuNgans.join(","); // Chuyển thành chuỗi ngăn cách bằng dấu phẩy
    // }
    const dataParams = {
      ...data,
      start: dayjs(data.start).format(FORMAT_TIME.dateTimeH),
      end: dayjs(data.end).format(FORMAT_TIME.dateTimeH),
      ...(data.ngaySinh && {
        ngaySinh: dayjs(data.ngaySinh).format(FORMAT_TIME.dayFull),
      }),
    };

    if (
      !dataParams.start ||
      !dataParams.end ||
      dataParams.start == "Invalid Date" ||
      dataParams.end == "Invalid Date"
    ) {
      Notification("warning", "Vui lòng chọn ngày");
      return;
    }
    const startDate = dayjs(data.start);
    const endDate = dayjs(data.end);
    const dateDifference = endDate.diff(startDate, 'day');
  
    if (dateDifference > 20) {
      Notification("warning", "Vui lòng chọn khoảng thời gian không vượt quá 20 ngày");
      setLoadingPage(false);
      return;
    }
    // console.log('data config export', newData);
    try {
      const response = await accoutingFinancial
        .getExportMarketing(dataParams)
        .then((res) => {
          // console.log("res export", res);
          var link = document.createElement("a");
          const url = window.URL.createObjectURL(res.data);
          link.href = url;
          link.download = `Báo cáo Marketing.xlsx`;
          link.click();
          setLoadingPage(false);
          Notification("success", "Đã xuất file báo cáo");
        });
    } catch (error) {
      setLoadingPage(false);
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    showSizeChanger: true,
    pageSize: pageSize,
    onChange: handlePaginationChange,
  };
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  useEffect(() => {
    const todayStartWithTime = dayjs()
      .set("hour", 0)
      .set("minute", 0)
      .set("second", 0);
    const todayEndWithTime = dayjs()
      .set("hour", 23)
      .set("minute", 59)
      .set("second", 59);
    form.setFieldValue("start", todayStartWithTime);
    form.setFieldValue("end", todayEndWithTime);
  }, []);
  return (
    <Spin spinning={loadingPage}>
      <div className="report-pay-tab-container">
        <div className="container">
          <Form form={form} onFinish={handleOnFinish}>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                <InputFields data={fields} />
              </Row>
              <Row justify={"end"} style={{ marginTop: "16px" }}>
                <Space>
                  <Button
                    icon={<ExcelSVG />}
                    className="custom-btn"
                    onClick={handelOnExport}
                  >
                    Xuất báo cáo
                  </Button>
                  <Button
                    icon={<Icon.eye />}
                    className="btn-sub"
                    htmlType="submit"
                  >
                    Xem thông tin
                  </Button>
                  <Popover
                    trigger="click"
                    placement="topLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={columns}
                        width={"400px"}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button
                      icon={<Icon.bars />}
                      className="btn-sub"
                      type="primary"
                    >
                      Cột hiển thị
                    </Button>
                  </Popover>
                </Space>
              </Row>
            </Space>
          </Form>
        </div>
        <div className="container">
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={data}
            loading={loading}
            columns={columns}
            scroll={{ x: 2500 }}
          />
        </div>
      </div>
    </Spin>
  );
};

export default Marketing;
